// vendorSlice.js
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import api from '../utils/api';


export const getManufacturerThunk = createAsyncThunk(
  'vendor/getManufacturerThunk',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.getManufacturer();
      return response.data?.data;
    } catch (error) {
      console.log(error);
      toast.error('something went wrong')

    }
  }
);



// The multi-step registration keeps its draft in sessionStorage so a page refresh between
// the steps does not lose the name / email / password typed on the first step.
const DRAFT_KEY = 'ew_vendor_regn_draft';
const readDraft = () => {
  try { return JSON.parse(sessionStorage.getItem(DRAFT_KEY) || '{}') || {}; } catch (e) { return {}; }
};
const writeDraft = (data) => {
  try {
    if (data && Object.keys(data).length) sessionStorage.setItem(DRAFT_KEY, JSON.stringify(data));
    else sessionStorage.removeItem(DRAFT_KEY);
  } catch (e) { /* storage unavailable: the draft just lives in memory */ }
};

const initialState = {
  vendorData: readDraft(), 
  loading:false,
  manufacturers:[],
  sameAddress:false
};

const vendorSlice = createSlice({
  name: 'vendor',
  initialState,
  reducers: {
    setVendorData: (state, action) => {
      state.vendorData = { ...state.vendorData, ...action.payload };
      writeDraft(state.vendorData);
    },
    setVendorAddress: (state, action) => {
      state.sameAddress = !state.sameAddress
    },
    deletevendorData:(state,action)=>{
      state.vendorData = {}
      writeDraft({})
    }
  },
   extraReducers: (builder) => {
      builder
  
        .addCase(getManufacturerThunk.pending, (state) => {
          state.loading = true;
        })
        .addCase(getManufacturerThunk.fulfilled, (state, action) => {
          state.loading = false;
          state.manufacturers = action.payload
        })
        .addCase(getManufacturerThunk.rejected, (state, action) => {
          state.loading = false;
        })
  
 
    },

});

export const { setVendorData,setVendorAddress ,deletevendorData} = vendorSlice.actions;

export default vendorSlice.reducer;
